//@flow strict
import type {MenuGroupTitleOption} from '@spaced-out/ui-design-system/lib/components/Menu';
import type {AtsClientEntity} from 'src/types/ats-entities';
import startCase from 'lodash/startCase';


export const getBrandDisplayName = (
  brandName: ?string,
  isPrimary: boolean,
): string => {
  if (brandName) {
    return isPrimary ? `${brandName} (Default)` : brandName;
  }
  return 'Unknown Brand';
};

export const getGroupedEntityOptions = (
  entities: Array<AtsClientEntity>,
  customerBusinessType: string,
): Array<MenuGroupTitleOption> => {
  const entityOptions = [];
  const leadEntityOptions = [];

  entities.forEach(({name, display_name, is_lead_entity}) => {
    if (
      // check whether to show the entity in the dropdown
      !(
        name === 'ae_client_company_employee' &&
        customerBusinessType === 'corporate'
      )
    ) {
      const entity = {
        key: name,
        label: startCase(display_name),
      };
      if (!is_lead_entity) {
        entityOptions.push(entity);
      } else {
        leadEntityOptions.push(entity);
      }
    }
  });

  return [
    {
      groupTitle: 'LEADS',
      options: leadEntityOptions,
    },
    {
      groupTitle: 'ATS FIELDS',
      options: entityOptions,
    },
  ];
};
